import { cx } from 'class-variance-authority';
import type { HTMLAttributes } from 'react';

export type ShimmerProps = HTMLAttributes<HTMLDivElement> & {
  height?: string | number;
  width?: string | number;
};

const Shimmer = ({
  'aria-hidden': ariaHidden,
  'aria-valuetext': ariaValueText = 'Loading...',
  className,
  height,
  width,
  style,
  ...props
}: ShimmerProps) => {
  return (
    <div
      className={cx('fp-shimmer', className)}
      aria-busy="true"
      aria-hidden={ariaHidden}
      aria-valuemax={100}
      aria-valuemin={0}
      aria-valuetext={ariaValueText}
      role="progressbar"
      style={{ height, width, ...style }}
      {...props}
    />
  );
};

export default Shimmer;
